import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { EventInventoryRecord } from "@src/store/pricing/queryEventInventoryAllSlice";
import { RootState } from "@src/store/store";
import { DeliveryClassification } from "@src/utils/deliveryClassification";
import { pricingActions } from "..";

const initialState = false;

export interface IUpdateListingExternalNotes {
	listingIds: Array<number>;
	externalNotes: string;
	appendNotes: boolean;
	deliveryClassification: DeliveryClassification;
}

export const { thunk: updateListingExternalNotes, slice: updateListingExternalNotesSlice } = getThunkAndSlice<
	IUpdateListingExternalNotes,
	typeof initialState
>({
	initialState,
	path: "/api/Pricing/UpdateListingExternalNotes",
	method: "post",
	onAfterRequest: async (data, params, state, dispatch) => {
		const rootState = state as RootState;
		const eventId = rootState.pricing.selection.event?.Event_ID;
		const isEDelivery = params.deliveryClassification === "EDELIVERY";
		const apply = <T extends { Listing_ID: number }>(item: T): T =>
			params.listingIds.includes(item.Listing_ID)
				? { ...item, External_Notes: params.externalNotes, SH_eDelivery: isEDelivery }
				: item;

		dispatch(pricingActions.updateInventoryAll({ data: rootState.pricing.eventInventoryAll.data.map(apply), eventId }));

		if (rootState.pricing.globalInventory.data.length) {
			dispatch(
				pricingActions.updateGlobalInventory({
					data: (rootState.pricing.globalInventory.data as Array<EventInventoryRecord>).map(apply),
				}),
			);
		}

		return data;
	},
});
